import { api } from "..";
const endpoint = "/api/clients";

export const getClientList = async (queryParams) => {
  return await api.get(`${endpoint}`, { params: queryParams });
};

export const createClient = async (data) => {
  return await api.post(`${endpoint}`, data);
};

export const updateClient = async (id, data) => {
  return await api.put(`${endpoint}/${id}`, data);
};

export const deleteClient = async (id) => {
  return await api.delete(`${endpoint}/${id}`);
};

export const getClientById = async (id) => {
  return await api.get(`${endpoint}/${id}`);
};

// CLIENT ADDRESSES
export const getClientAddressesList = (clientId) => {
  return api.get(`${endpoint}/address/${clientId}`);
};

export const addClientAddress = (data) => {
  return api.post(`${endpoint}/address/`, data);
};

export const updateClientAddress = (id, data) => {
  return api.put(`${endpoint}/address/${id}`, data);
};

export const deleteClientAddress = (id) => {
  return api.delete(`${endpoint}/address/${id}`);
};

// CLIENT WAREHOUSES
export const getClientWarehouseList = (queryParams) => {
  return api.get(`${endpoint}/warehouses/`, { params: queryParams });
};

export const getClientWarehouseById = (id) => {
  return api.get(`${endpoint}/warehouses/${id}`);
};

export const addClientWarehouse = (data) => {
  return api.post(`${endpoint}/warehouses/`, data);
};

export const updateClientWarehouse = (id, data) => {
  return api.put(`${endpoint}/warehouses/${id}`, data);
};

export const deleteClientWarehouse = (id) => {
  return api.delete(`${endpoint}/warehouses/${id}`);
};
